import type { PhraseListParams } from '@/entities/phrases';
import { PHRASE_COLUMNS, SORTABLE_PHRASE_COLUMNS } from './constants';
import type { AudioAuditState, NumberRange, TimestampRange } from './types';

/** Продолжительность пользователь вводит в секундах, а контракт перечня считает её в миллисекундах */
const toMilliseconds = (seconds?: number): number | undefined =>
  seconds === undefined || Number.isNaN(seconds) ? undefined : Math.round(seconds * 1000);

/** Переводит окно, отбор и порядок таблицы в условия запроса перечня реплик. */
export const toPhraseListParams = ({ page, pageSize, sorting, filters }: AudioAuditState): PhraseListParams => {
  const conversationId = filters[PHRASE_COLUMNS.conversationId]?.value as NumberRange | undefined;
  const duration = filters[PHRASE_COLUMNS.duration]?.value as NumberRange | undefined;
  const updatedAt = filters[PHRASE_COLUMNS.updatedAt]?.value as TimestampRange | undefined;
  const activeSort = sorting[0];
  const sortKey = activeSort ? SORTABLE_PHRASE_COLUMNS[activeSort.columnId] : undefined;

  return {
    limit: pageSize,
    offset: page * pageSize,
    sort: sortKey ? `${sortKey}:${activeSort.direction}` : undefined,
    conversationIdFrom: conversationId?.from,
    conversationIdTo: conversationId?.to,
    durationFrom: toMilliseconds(duration?.from),
    durationTo: toMilliseconds(duration?.to),
    updatedAtFrom: updatedAt?.from || undefined,
    updatedAtTo: updatedAt?.to || undefined,
  };
};
